define('main',['require','exports','module'],function(require, exports, module) {
// Break out the application running from the configuration definition to
// assist with testing.
require(["config"], function(config) {
  // Kick off the application.
  require(["app", "services/auth"], function(app, Auth) {
    app.i18nInit(function () {
      Auth.login(function (isLogged) {
        if (isLogged) {
          Auth.getCompanyInfo(app.setCompanyInfo);
          app.start();
        }
      });
    });
  });
});

});
